import authService from './authService';
import apiClient from './apiClient';

function authHeaders() {
  const token = authService.getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

class QuestionService {
  async listQuestions(params = {}) {
    try {
      const res = await apiClient.get('/admin/questions', { params, headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      if (e.response?.status === 403) {
        window.location.href = '/forbidden';
        throw new Error('Access denied');
      }
      throw e;
    }
  }

  async createQuestion(payload) {
    try {
      const res = await apiClient.post('/admin/questions', payload, { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      if (e.response?.status === 403) {
        window.location.href = '/forbidden';
        throw new Error('Access denied');
      }
      throw e;
    }
  }

  async updateQuestion(id, payload) {
    try {
      const res = await apiClient.put(`/admin/questions/${id}`, payload, { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async deleteQuestion(id) {
    try {
      await apiClient.delete(`/admin/questions/${id}`, { headers: authHeaders() });
      return true;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async getQuizConfig() {
    try {
      const res = await apiClient.get('/admin/config', { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async getPublicQuizConfig() {
    const res = await apiClient.get('/quiz/config', { headers: authHeaders() });
    return res.data;
  }

  async getQuizAttempt() {
    const res = await apiClient.get('/quiz/attempt', { headers: authHeaders() });
    return res.data;
  }

  async updateQuizConfig(payload) {
    try {
      const res = await apiClient.put('/admin/config', payload, { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async getRandomizedQuestions(params = {}) {
    const res = await apiClient.get('/quiz/questions', { params, headers: authHeaders() });
    return res.data;
  }

  async getScenarios(limit = 5) {
    const res = await apiClient.get('/quiz/scenarios', { params: { limit }, headers: authHeaders() });
    return res.data;
  }

  async listScenarios(skip = 0, limit = 50) {
    try {
      const res = await apiClient.get(`/admin/scenarios?skip=${skip}&limit=${limit}`, { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async createScenario(payload) {
    try {
      const res = await apiClient.post('/admin/scenarios', payload, { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async updateScenario(id, payload) {
    try {
      const res = await apiClient.put(`/admin/scenarios/${id}`, payload, { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async deleteScenario(id) {
    try {
      await apiClient.delete(`/admin/scenarios/${id}`, { headers: authHeaders() });
      return true;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async getFinalTest() {
    const res = await apiClient.get('/quiz/final_test', { headers: authHeaders() });
    return res.data;
  }

  async listFinalTests() {
    try {
      const res = await apiClient.get('/admin/final_test', { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async createFinalTest(payload) {
    try {
      const res = await apiClient.post('/admin/final_test', payload, { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async updateFinalTest(id, payload) {
    try {
      const res = await apiClient.put(`/admin/final_test/${id}`, payload, { headers: authHeaders() });
      return res.data;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }

  async deleteFinalTest(id) {
    try {
      await apiClient.delete(`/admin/final_test/${id}`, { headers: authHeaders() });
      return true;
    } catch (e) {
      if (e.response?.status === 401) {
        authService.logout();
        authService.redirectToMicrosoftLogin();
        throw new Error('Session expired. Please login again.');
      }
      throw e;
    }
  }
}

export default new QuestionService();
